import React from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Gift, Truck, Key, Package } from 'lucide-react';

const rewards = [
  { id: 1, title: '5% Discount on Next Order', description: 'Use this reward to get a 5% discount on your next purchase.', points: 5000, icon: <Gift size={24} /> },
  { id: 2, title: 'Free Shipping', description: 'Enjoy free shipping on orders above ₹5,000.', points: 8000, icon: <Truck size={24} /> },
  { id: 3, title: 'Exclusive Access', description: 'Get early access to new collections.', points: 12000, icon: <Key size={24} /> },
  { id: 4, title: 'Premium Packaging', description: 'Your orders will be delivered in premium packaging.', points: 15000, icon: <Package size={24} /> },
];

const RewardsGrid = () => (
  <Box>
    <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, color: 'text.primary' }}>
      Available Rewards
    </Typography>
    <Grid container spacing={3}>
      {rewards.map((reward) => (
        <Grid item xs={12} sm={6} md={3} key={reward.id}>
          <Card className="rewards-grid-card">
            <CardContent>
              <Box sx={{
                width: 48,
                height: 48,
                borderRadius: 'var(--radius-md)',
                background: 'linear-gradient(135deg, var(--brand-primary-100) 0%, var(--brand-primary-50) 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 2,
                color: 'var(--brand-primary)',
              }}>
                {reward.icon}
              </Box>
              <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                {reward.title}
              </Typography>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, lineHeight: 1.5 }}>
                {reward.description}
              </Typography>
              <Typography variant="subtitle1" sx={{
                fontWeight: 700,
                color: 'var(--brand-primary)',
                fontSize: '1.1rem',
                mt: 'auto',
                pt: 1,
                borderTop: '1px solid var(--color-border)',
              }}>
                {reward.points.toLocaleString()} JP
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default RewardsGrid;